import React, { useCallback, useState } from 'react'
import { DonateButton, SubscribeModal, StickyPhone } from 'ppp'
import { ShareButtons, formatNumber, gaEvent, useProject } from 'shared'
import { StickyProps } from './types'
import { AdminButtonProps } from './types'

export const Sticky = ({
  activeTab,
  apiUrl,
  showManageTab,
  manageUrl,
  pppUrl,
  opinionsUrl,
  newsletterSubscriptionUrl,
  newsUrl,
  shareUrl,
}: StickyProps): JSX.Element => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false)

  const openSubscriptionModal = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__sticky')
    setShowSubscriptionModal(true)
  }, [])

  const hideSubscriptionModal = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__sticky')
    setShowSubscriptionModal(false)
  }, [])

  const activeClassFor = (tab: string | undefined) => (tab === activeTab ? 'active' : '')

  const { status, ...project } = useProject(apiUrl)

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-16" style={{ minHeight: 0 }}>
            <ul className="list-unstyled navigation-list">
              <AdminButton showManageTab={showManageTab} manageUrl={manageUrl} />
              <li className={activeClassFor('overview')}>
                <a href={pppUrl}>
                  <span className="hidden desktop:inline">{I18n.t('projects.show.sticky.overview_button_label')}</span>
                  <span className="desktop:hidden">{I18n.t('projects.show.sticky.overview_button_mobile_label')}</span>
                </a>
              </li>
              <li className={activeClassFor('opinions')}>
                <a href={opinionsUrl}>
                  {I18n.t('projects.show.sticky.donation_list_button_label')}{' '}
                  <span className="hidden desktop:inline">({formatNumber(project.donations_count)})</span>
                </a>
              </li>
              <li className={activeClassFor('news')}>
                <a href={newsUrl}>
                  {I18n.t('projects.show.sticky.news_button_label')}{' '}
                  <span className="hidden desktop:inline">({formatNumber(project.blog_post_count)})</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-8">
            <div className="meta-navigation">
              <SubscribeModal
                show={showSubscriptionModal}
                project={project}
                onHide={hideSubscriptionModal}
                url={newsletterSubscriptionUrl}
              />

              <ShareButtons
                platforms={['facebook', 'whatsapp']}
                mobileOnly={['whatsapp']}
                shape="square"
                shareUrl={shareUrl}
                status={status}
                className="without-labels"
                gaLabel="ppp_sticky"
              >
                <a
                  className="heart-shape-container"
                  onClick={openSubscriptionModal}
                  title={I18n.t('projects.show.share_buttons.become_a_fan')}
                >
                  <i className="fa fa-heart" />
                </a>
              </ShareButtons>
              <DonateButton
                project={project}
                status={status}
                gaAction="click donate_button__sticky"
                className="btn-large"
              />
            </div>
          </div>
        </div>
      </div>
      <StickyPhone project={project} status={status} />
    </>
  )
}

const AdminButton = ({ showManageTab, manageUrl }: AdminButtonProps): JSX.Element | null => {
  if (showManageTab !== 'true') return null

  return (
    <li className="admin-tab">
      <a href={manageUrl}>{I18n.t('projects.show.sticky.manage_button_label')}</a>
    </li>
  )
}
